@if (contractParametersResource.isLoading()) {
  <app-loading />
} @else {
  <app-proposal-parameter-panels
    [projectId]="projectId()!"
    [contractParametersContainer]="contractParametersResource.value()!"
    [isReadOnly]="true"
  />
}
